export default {
  title: 'Media Page',
  header: 'Media',
  sort: {
    latest: 'Latest',
    oldest: 'Oldest',
    size: 'File Size',
    type: 'File Type',
  }
}
